import { render, staticRenderFns } from "./stationDiscountGroupBase.vue?vue&type=template&id=b5d5bce8&"
import script from "./stationDiscountGroupBase.vue?vue&type=script&lang=js&"
export * from "./stationDiscountGroupBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5d5bce8')) {
      api.createRecord('b5d5bce8', component.options)
    } else {
      api.reload('b5d5bce8', component.options)
    }
    module.hot.accept("./stationDiscountGroupBase.vue?vue&type=template&id=b5d5bce8&", function () {
      api.rerender('b5d5bce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stationManage/stationDiscount/stationDiscountGroupBase.vue"
export default component.exports